import { render } from "./HasOneThroughField.vue?vue&type=template&id=7613fb90"
import script from "./HasOneThroughField.vue?vue&type=script&lang=js"
export * from "./HasOneThroughField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasOneThroughField.vue"]])

export default __exports__